import styled from "@emotion/styled"
import SVG from "assets/svg"
import patternBackground from "assets/images/pattern-background-2fa.png"
import { color, size, space } from "rentpost/styles"
import { LogoLink } from "components/other"
import { useNavigate } from "react-router-dom"
import ROUTE from "routes/ROUTE"

const Illustration = () => {
   const navigate = useNavigate()

   return (
      <Holder>
         <div className="desktop">
            <LogoLink />
            <SVG.TwoFactorAuthSVG className="phone-with-biometrics-svg" />
            <img src={patternBackground} alt="pattern-background" />
         </div>
         <div className="tablet-and-mobile" onClick={() => navigate(ROUTE.INDEX)}>
            <div className="logo">
               <SVG.logo.wordColored className="colored" />
               <SVG.logo.word className="white" />
            </div>
            <div className="image-holder">
               <SVG.TwoFactorAuthSVG className="phone-with-biometrics-svg" />
               <img src={patternBackground} alt="pattern-background" />
            </div>
         </div>
      </Holder>
   )
}

const Holder = styled.div`
   .desktop {
      position: relative;
      isolation: isolate;
      height: 100%;
      width: 26vw;
      overflow: hidden;
      background: linear-gradient(180deg, #e291ff 0%, #50a999 100%);
      .logo {
         position: absolute;
         top: ${space.xl};
         left: ${space.xl};
         width: 11em;
         z-index: 3;
         fill: ${color.white};
      }

      .phone-with-biometrics-svg {
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         font-size: ${size.l};
         width: 12em;
         z-index: 2;
      }
      img {
         position: absolute;
         bottom: 0;
         height: 100%;
      }
   }

   /* -------------- */
   /* Responsiveness */
   /* -------------- */

   .tablet-and-mobile {
      display: flex;

      .image-holder {
         background: linear-gradient(180deg, #e291ff 0%, #50a999 100%);
         opacity: calc(1 - var(--animation-factor) + 0);

         .phone-with-biometrics-svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: ${size.l};
            width: 8em;
            z-index: 2;
         }

         img {
            position: absolute;
            top: 0;
            width: 100%;
         }
      }
   }
`

export default Illustration
